<script setup lang="ts">
import NavbarSettingsItem from "../NavbarSettingsItem.vue";
import NavbarNotificationsPanel from "./NavbarNotificationsPanel.vue";
import { useNavbarNotifications } from "./useNavbarNotifications";

const { t } = useI18n();
const { checkUnreadCount, refetch } = useNavbarNotifications();

const TRANSLATION_KEY = "navbar.dropdown";
</script>

<template>
  <VDropdown
    theme="verbleif-popper-bounded"
    placement="right"
    @show="() => {
      void refetch();
      checkUnreadCount();
    }"
  >
    <template #popper>
      <NavbarNotificationsPanel />
    </template>
    <button
      type="button"
      class="block w-full text-left focus-visible:ring-2 focus-visible:ring-[#4CAF58] focus-visible:outline-hidden focus-visible:ring-inset"
    >
      <NavbarSettingsItem icon="bell" :text="t(`${TRANSLATION_KEY}.notifications`)" chevron />
    </button>
  </VDropdown>
</template>
